// extracted by mini-css-extract-plugin
module.exports = {"card":"card-module--card--2MkX_","background":"card-module--background--2W-ga","content":"card-module--content--EZenK","title":"card-module--title--1rsQL"};